(() => {
  const videos = Array.from(document.querySelectorAll('[data-abt-video]')).filter(video => !video.dataset.abtVideoReady);
  if (!videos.length || !('IntersectionObserver' in window)) return;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const autoplayAllowed = () => !motion.matches && !(navigator.connection && navigator.connection.saveData);
  const update = (video, state) => {
    if (document.hidden || !state.visible) {
      video.pause();
    } else if (autoplayAllowed() && !state.manual) {
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      update(entry.target, state);
    });
  }, { threshold: [0, 0.5] });

  videos.forEach(video => {
    video.dataset.abtVideoReady = 'true';
    const state = { visible: false, manual: false };
    states.set(video, state);
    video.addEventListener('pointerdown', () => { state.manual = true; }, { passive: true });
    video.addEventListener('keydown', () => { state.manual = true; });
    observer.observe(video);
  });
  document.addEventListener('visibilitychange', () => {
    states.forEach((state, video) => update(video, state));
  });
  motion.addEventListener('change', () => {
    states.forEach((state, video) => {
      if (motion.matches) video.pause();
      else update(video, state);
    });
  });
})();
